import { Endpoint } from '@business/api/endpoint';
import { TMChangeOrderTypeId, TMChangeOrderTypeRequest, TMChangeOrderTypeResponse } from '@business/entities/tm';

export function fetchChangeOrderTypes() {
  return Endpoint.get<TMChangeOrderTypeResponse[]>(`@gc/tm-change-order-types`);
}

export function createChangeOrderType(data: TMChangeOrderTypeRequest) {
  return Endpoint.post<TMChangeOrderTypeResponse>(`@gc/tm-change-order-types`, { data });
}

// changeNote: the reason for the change (required, kept in the Activity Log)
export function updateChangeOrderType(id: TMChangeOrderTypeId, data: TMChangeOrderTypeRequest, changeNote: string) {
  return Endpoint.patch<TMChangeOrderTypeResponse>(`@gc/tm-change-order-types/${id}`, { data: { ...data, changeNote } });
}

export function deleteChangeOrderType(id: TMChangeOrderTypeId, changeNote: string) {
  return Endpoint.delete<{ success: boolean }>(`@gc/tm-change-order-types/${id}`, { data: { changeNote } });
}
